import { Boot } from '@wangeditor/editor'

class AttachmentMenu {
  constructor() {
    this.title = '附件上传'
    this.iconSvg = '<svg viewBox="0 0 1024 1024"><path d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 896H232V136h302v216a42 42 0 0 0 42 42h216v502z"></path><path d="M402 618c0 4.4 3.6 8 8 8h204c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H410c-4.4 0-8 3.6-8 8v48zM402 502c0 4.4 3.6 8 8 8h204c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H410c-4.4 0-8 3.6-8 8v48z"></path></svg>'
    this.tag = 'button'
  }

  getValue(editor) {
    return ''
  }

  isActive(editor) {
    return false
  }

  isDisabled(editor) {
    return false
  }

  exec(editor, value) {
    // 创建文件输入元素
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.doc,.docx,.pdf,.txt,.xls,.xlsx,.ppt,.pptx'
    input.style.display = 'none'
    
    input.onchange = (e) => {
      const file = e.target.files[0]
      if (file) {
        // 触发自定义事件，让父组件处理文件上传
        const event = new CustomEvent('attachment-upload', {
          detail: { file, editor }
        })
        document.dispatchEvent(event)
      }
    }
    
    document.body.appendChild(input)
    input.click()
    document.body.removeChild(input)
  }
}

const attachmentMenuConf = {
  key: 'uploadAttachment',
  factory() {
    return new AttachmentMenu()
  }
}

// 注册菜单
Boot.registerMenu(attachmentMenuConf)

export default AttachmentMenu